import React, { Component } from 'react';
import { DateTimeHelper } from '../Helpers/DateTimeHelper';

import { t } from '../locales/i18n';

import { MainRouter } from '../Components/MainRouter';
import { Modal } from '../Components/Modal';
import { OrderDetails } from '../Components/OrderDetails';
import { ShipmentSummary } from '../Components/ShipmentSummary'
import { TopSection } from '../Components/TopSection';

import { ReactComponent as Processing } from '../Images/LoadingShipment.svg';
import { ReactComponent as InTransit } from '../Images/ShipmentTravelling.svg';
import { ReactComponent as Delivered } from '../Images/CheersMakingBeer.svg';
import { ReactComponent as Info } from '../Images/Info.svg';
import { ReactComponent as OrderDetailsIcon } from '../Images/OrderDetails.svg';
import { ReactComponent as ShipmentSummaryIcon } from '../Images/ShipmentSummary.svg';
import { ReactComponent as Chevron } from '../Images/Chevron.svg';

export class SmallCarrierPage extends Component {
    static displayName = SmallCarrierPage.name;

    constructor(props) {
        super(props);

        window.ga('set', 'page', window.location.pathname + window.location.search);
        window.ga('send', 'pageview');

        this.state = {
            data: JSON.parse(sessionStorage.getItem('data')),
            showModal: false,
            modalTitle: '',
            modalBody: ''
        };

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.detailsClick = this.detailsClick.bind(this);
        this.summaryClick = this.summaryClick.bind(this);

        // Coalesce date into a single value.
        this.deliveryDate = this.state.data.deliveryETA

        this.shipmentStatus = this.state.data.shipmentStatus.toUpperCase();
    }

    render() {

        return (
            <MainRouter>
                <div>
                    <TopSection data={this.state.data} />
                    <div className='line' />
                    <div className='center fit-content desktop-view'>
                        <div className='center fit-content bottom-10'>
                            <div className='status-col'>
                                <div className="ellipse-selected">
                                    <Processing className='status-image-1' />
                                </div>
                                <div className={this.isInStatus(['INTRANSIT', 'DELIVERED']) ? 'connector-complete' : 'connector-pending'} />
                            </div>
                            <div className='status-col'>
                                <div className={this.isInStatus(['INTRANSIT', 'DELIVERED']) ? 'ellipse-selected' : 'ellipse'}>
                                    <InTransit className='status-image-2' />
                                </div>
                            <div className={this.isInStatus(['DELIVERED']) ? 'connector-complete' : 'connector-pending'} />
                            </div>
                            <div className='status-col-last'>
                                <div className={this.isInStatus('DELIVERED') ? 'ellipse-selected' : 'ellipse'}>
                                    <Delivered className='status-image-3' />
                                </div>
                            </div>
                        </div>
                        <div className='row status-width'>
                            <div className='col-4'>
                                <div className='center fit-content'>
                                    <h4 className={this.isInStatus('PROCESSING') ? '' : 'status-text-pending'}>{t('smallCarrier.status.processing')}</h4>
                                    {this.isInStatus('PROCESSING') &&
                                        <Info className='info-image' onClick={() => this.showModal('PROCESSING')} />
                                    }
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='center fit-content'>
                                    <h4 className={this.isInStatus('INTRANSIT') ? '' : 'status-text-pending'}>{t('smallCarrier.status.inTransit')}</h4>
                                    {this.isInStatus('INTRANSIT') &&
                                        <Info className='info-image' onClick={() => this.showModal('INTRANSIT')} />
                                    }
                                </div>
                            </div>
                            <div className='col-4'>
                                <div className='center fit-content'>
                                    <h4 className={this.isInStatus('DELIVERED') ? '' : 'status-text-pending'}>{t('smallCarrier.status.delivered')}</h4>
                                    {this.isInStatus('DELIVERED') &&
                                        <Info className='info-image' onClick={() => this.showModal('DELIVERED')} />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='center mobile-view'>
                        <div className='center ellipse-mobile bottom-10'>
                            {
                                this.isInStatus('PROCESSING') ? <Processing className='status-image-1' /> :
                                    this.isInStatus('INTRANSIT') ? <InTransit className='status-image-2' /> :
                                        <Delivered className='status-image-3' />
                            }
                        </div>
                        <div className='center fit-content'>
                            <h4>
                                {
                                    this.isInStatus('PROCESSING') ? t('smallCarrier.status.processing') :
                                        this.isInStatus('INTRANSIT') ? t('smallCarrier.status.inTransit') : t('smallCarrier.status.delivered')
                                }
                            </h4>
                            <Info className='info-image' onClick={() => this.showModal(this.state.data.shipmentStatus)} />
                            {this.isInStatus('DELIVERED') &&
                                <div className='center'>
                                    {DateTimeHelper.formatDateTime(this.deliveryDate, 'lll')}
                                </div>
                            }
                        </div>
                    </div>
                    <div className='line' />
                    <div className='row order-details-section'>
                        <div className='col-xl-3 desktop-view'>
                            <h4 className='bottom-20'>{t('smallCarrier.sections.orderDetails')}</h4>
                            <OrderDetails data={this.state.data} />
                        </div>
                        <div className='col-8 center btn-sub-mobile mobile-view bottom-10' onClick={this.summaryClick}>
                            <ShipmentSummaryIcon className='adjust-shipment-summary-image' />
                            <h4 className='shipment-summary-text-mobile'>{t('smallCarrier.sections.shipmentSummary')}</h4>
                            <Chevron className='right down-15' />
                        </div>
                        <div className='col-8 center btn-sub-mobile mobile-view bottom-20' onClick={this.detailsClick}>
                            <OrderDetailsIcon className='adjust-order-details-image' />
                            <h4 className='order-details-text-mobile'>{t('smallCarrier.sections.orderDetails')}</h4>
                            <Chevron className='right down-15' />
                        </div>
                        <div className='col-xl-5'>
                            <div className='center shipment-section desktop-view'>
                                <ShipmentSummary data={this.state.data} />
                            </div>
                        </div>
                        <div className={this.state.data.notes ? 'col-xl-4' : 'hide'}>
                            <div className='bottom-20 desktop-view'>
                                <h4>{t('smallCarrier.sections.notes')}</h4>
                            </div>
                            <div className='mobile-view'>{t('smallCarrier.sections.notesMobile')}</div>
                            {this.state.data.notes}
                        </div>
                    </div>
                </div>
                {this.state.showModal &&
                    <Modal onClose={this.closeModal}
                           title={this.state.modalTitle}
                           body={this.state.modalBody}
                           centerBodyText='true'
                    />}
            </MainRouter>
        );
    }

    showModal(target) {
        var state = this.state;
        var msg = '';

        if (target.toUpperCase() === 'PROCESSING') {
            state.modalTitle = t('smallCarrier.status.processing');
            msg = t('smallCarrier.status.processingMsg');
        }
        else if (target.toUpperCase() === 'INTRANSIT') {
            state.modalTitle = t('smallCarrier.status.inTransit');
            msg = t('smallCarrier.status.inTransitMsg');
        }
        else {
            state.modalTitle = t('smallCarrier.status.delivered');
            msg = t('smallCarrier.status.deliveredMsg');
        }

        state.modalBody = `<div>${msg}</div><div class="stage-of-process">${t('smallCarrier.status.stageNote')}</div>`;
        state.showModal = true;
        this.setState(state);
    }

    isInStatus(status) {
        if (status && status.length)
            return status.indexOf(this.shipmentStatus) >= 0;

        return this.shipmentStatus === status;
    }

    closeModal() {
        var state = this.state;
        state.showModal = false;
        this.setState(state);
    }

    detailsClick() {
        MainRouter.routeTo('/orderdetails', '/smallcarrier', this.state.data);
    }

    summaryClick() {
        MainRouter.routeTo('/shipmentsummary', '/smallcarrier', this.state.data);
    }
}
